import {useState} from "react";

// Components

// Scss
// import '../assets/css/partnerProgram.scss';
import '../assets/css/partnerPortal/welcome.scss';

import ButtonArrow from "./ButtonArrow";

function NewsRow(props) {


  const [info] = useState(props.info);
  const [link] = useState(props.link);
  const [title] = useState(props.title);
  const [putIcon] = useState(props.putIcon);
  const [buttonName] = useState(props.buttonName);
  const [arrowWidth] = useState(props.arrowWidth);

  function addTitle() {
    if (title) {
      return <div className="newsTitle">{title}</div>
    }

    if (putIcon) {
      return <div className="newImage">
                <div className="newText">New</div>

            </div>
    }
  }

  return (
    <>
      
      <div className="mb-3">
        {addTitle()}
        <div className="frameText mb-1">
          {info}
        </div>
        <ButtonArrow link={link} buttonName={buttonName ? buttonName : "Read More "} width={arrowWidth ? arrowWidth : "6%"}/>
      </div>
            
    </>
  );


}

export default NewsRow;

